var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.025 18.975H6.45L16.1 9.325L14.675 7.9L5.025 17.55V18.975ZM3.975 21.05C3.69167 21.05 3.45 20.95 3.25 20.75C3.05 20.55 2.95 20.3083 2.95 20.025V17.55C2.95 17.2833 3 17.025 3.1 16.775C3.2 16.525 3.35 16.3 3.55 16.1L16.15 3.525C16.35 3.34167 16.5667 3.2 16.8 3.1C17.05 3 17.3083 2.95 17.575 2.95C17.8417 2.95 18.1 3 18.35 3.1C18.6167 3.2 18.8417 3.35 19.025 3.55L20.475 5.025C20.675 5.20833 20.8167 5.425 20.9 5.675C21 5.925 21.05 6.18333 21.05 6.45C21.05 6.71667 21 6.975 20.9 7.225C20.8167 7.45833 20.675 7.675 20.475 7.875L7.9 20.45C7.71667 20.65 7.49167 20.8 7.225 20.9C6.975 21 6.71667 21.05 6.45 21.05H3.975ZM18.975 6.45L17.55 5.025L18.975 6.45ZM15.375 8.625L14.675 7.9L16.1 9.325L15.375 8.625Z",
    fill: "#5F30E2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.c6b2d046fcbbcb41cc4c70af9e42e03d.svg";